/**
 * abstract class for openItems
 */
export default class OpenItem {
  constructor(item, status, extraProps) {
    this.item = item;
    this.status = status;
    this.extraProps = extraProps;
  }
}
